export const WASM_ENGINE_PROCESSOR_NAME = "engine-wasm-processor";
export const WASM_SYNC_CHANNEL = "engine-sync-bytes";
export const WASM_FROZEN_CHANNEL = "engine-frozen-audio";
